import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { COMPANY, SITE_URL, SUPPORT_EMAIL } from '../data/launch';
export function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-715" data-mp="2amizminws68d">
      <SEO title="Terms of Use | KittyPot" description="The terms for using the KittyPot app and website. KittyPot helps groups track shared expenses and settle up directly; it does not hold or move money." ogTitle="KittyPot Terms of Use" ogDescription="The terms for using the KittyPot app and website." path="/terms" data-id="element-716" data-mp="20q5vsryngbzw" />
      <Navbar data-id="element-717" data-mp="3q4ayu0vnodvi" />
      <main className="pt-32 pb-24" data-id="element-718" data-mp="3q2rjqdlqk8vb">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-719" data-mp="3m38ythtwzxsh">
          <h1 className="text-4xl font-black text-kitty-dark mb-4" data-id="element-720" data-mp="3m1o5twn90mwq">
            Terms of Use
          </h1>
          <p className="text-gray-500 font-medium mb-10" data-id="element-721" data-mp="2u3nx1quzawp3">
            Last updated: 26 August 2026
          </p>

          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-722" data-mp="2g4eggq2v20kl">
            <p data-id="element-723" data-mp="2k5hvxbgzxula">
              These terms apply when you use the KittyPot app or {SITE_URL} (the
              “Service”), provided by {COMPANY.legalName} (company number{' '}
              {COMPANY.registrationNumber}), referred to as “KittyPot”, “we” or
              “us”. By using the Service you agree to these terms.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-724" data-mp="2z1pg4bsemw0k">
              1. What KittyPot does
            </h2>
            <p data-id="element-725" data-mp="332j3n41xq8sx">
              KittyPot helps groups record shared expenses, split costs between
              members, and keep track of who owes what. It is a record-keeping
              tool.
            </p>
            <p data-id="element-726" data-mp="3vmrezww7qkm2">
              To be clear about what KittyPot is not: we do not hold your money,
              we do not operate a wallet or store group funds, and we do not
              transfer money between members. We are not a bank and we are not a
              payment service provider. Any payment between you and another
              member happens directly between you, outside KittyPot. We are not
              a party to it, we cannot guarantee that anyone will pay, and we do
              not adjudicate disputes between members of a kitty.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-727" data-mp="3hphryq5hwn3f">
              2. Your account
            </h2>
            <p data-id="element-728" data-mp="3dnd1u1e9a8lj">
              You need an account to use the full app. You must give accurate
              details, keep your sign-in secure, and let us know if you think
              someone else has access to your account. You are responsible for
              activity carried out under your account.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-729" data-mp="2oo9udrs4gyxo">
              3. Acceptable use
            </h2>
            <p data-id="element-730" data-mp="2tmjumgspepq5">When using KittyPot, you agree not to:</p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-731" data-mp="2tp60mbzy4x69">
              <li data-id="element-732" data-mp="2ynhb8oy2fbpj">use the Service for anything unlawful or fraudulent</li>
              <li data-id="element-733" data-mp="33m2c8ql55zf1">
                add someone to a kitty, or upload information about them,
                without a good reason to do so
              </li>
              <li data-id="element-734" data-mp="25vnu8va6mm7a">
                harass other members, or use expense descriptions and
                notifications to send abusive content
              </li>
              <li data-id="element-735" data-mp="2fuwv883gt135">
                attempt to disrupt the Service, access it without authorisation,
                or interfere with other people's data
              </li>
            </ul>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-736" data-mp="1n82dhiy18ftd">
              4. Creating and joining kitties
            </h2>
            <p data-id="element-737" data-mp="1s4j3kiosl493">
              You can create a kitty and invite others by link, code, QR or from
              your contacts, and people can take part from the app or from their
              browser. Members of a kitty can see that kitty's expenses,
              balances and settlement records. Only add people who should see
              that information.
            </p>
            <p data-id="element-738" data-mp="2oggexpdo1mu">
              A kitty may have one or more admins who can manage members, rename
              the kitty and close it. Admin roles are held by members using the
              app so that a kitty always has someone able to manage it.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-739" data-mp="qfcg0h02s14n">
              5. Expenses, balances and accuracy
            </h2>
            <p data-id="element-740" data-mp="lg9a6uc9tqvm">
              Everything KittyPot shows is calculated from information that you
              and other members enter. We do not verify amounts, and we cannot
              confirm that an expense really happened or that a split is fair.
              It is your responsibility to check that the amounts, payers and
              splits are right.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-741" data-mp="17n3mohhnjosl">
              6. Receipts
            </h2>
            <p data-id="element-742" data-mp="sypkm8s284d3">
              You can attach a receipt image to an expense. Where the app reads
              details from a receipt automatically, those details are a
              suggestion and may be wrong or incomplete. Always check them
              before saving. Only upload receipts you are entitled to share with
              the group.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-743" data-mp="a168uxe7w7mz">
              7. Settling up
            </h2>
            <p data-id="element-744" data-mp="f0927kku4pf4">
              Settlement in KittyPot is a record, not a payment. When you mark
              an amount as paid, you are telling the group that you have paid it
              elsewhere, and the person receiving it can confirm they got it.
              Disputes about whether a payment was actually made are between the
              members concerned.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-745" data-mp="22wz07qx1knmd">
              8. Currencies
            </h2>
            <p data-id="element-746" data-mp="1xyxc2rkrdy41">
              Where a kitty involves more than one currency, converted amounts
              shown in the app are for presentation only. They may not match the
              rate your bank or payment provider uses at the time you settle.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-747" data-mp="2lngggw0otqqu">
              9. Sharing bank details
            </h2>
            <p data-id="element-748" data-mp="2gvglzj3dzq1n">
              You may choose to save bank details so they are easy to share when
              your group settles up. This is optional, and you decide when to
              share them. KittyPot does not use them to make payments. Please
              take the same care you would take anywhere else when sharing
              account details.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-749" data-mp="r4pwnkk4s3nk">
              10. Your content
            </h2>
            <p data-id="element-750" data-mp="w3krxlzabkok">
              You keep ownership of the content you add, such as expense
              descriptions and receipt images. You give us permission to store
              and process that content, and to show it to the other members of
              the relevant kitty, so that we can provide the Service.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-751" data-mp="1a0zjoxd0g4jp">
              11. Our intellectual property
            </h2>
            <p data-id="element-752" data-mp="1jsdhn0pbcwaq">
              The KittyPot name, logo, app and website, including their design
              and software, belong to {COMPANY.legalName}. You may use them only
              as part of using the Service.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-753" data-mp="1sv4vt89kq662">
              12. Availability and changes
            </h2>
            <p data-id="element-754" data-mp="18p981pj3ie2c">
              We work to keep KittyPot available and running well, but we cannot
              promise it will be available without interruption. We may update,
              change or withdraw features, and we will give reasonable notice of
              significant changes where we can.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-755" data-mp="1do2j7bawtszc">
              13. Suspension and ending your account
            </h2>
            <p data-id="element-756" data-mp="pyzwhp1f59xz">
              You can delete your account at any time, see{' '}
              <Link to="/delete-account" className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-757" data-mp="l182mph7rdr5">
                Delete your KittyPot account
              </Link>
              . We may suspend or end access if these terms are seriously or
              repeatedly broken, or where we are required to by law. We will
              tell you why unless we are prevented from doing so.
            </p>
            <p data-id="element-758" data-mp="3o9uplhq5r3o0">
              When an account is deleted, we remove or anonymise the account
              information described in our{' '}
              <Link to="/privacy-policy" className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-759" data-mp="3t361hx9tuams">
                Privacy Policy
              </Link>
              . Limited shared kitty history may be kept in anonymised form so
              other members' records stay accurate.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-760" data-mp="fsqhe1fnoaw7">
              14. Our responsibility to you
            </h2>
            <p data-id="element-761" data-mp="5wdh2kpluysh">
              We provide KittyPot with reasonable care and skill. We are
              responsible for loss you suffer that is a foreseeable result of us
              breaking these terms or failing to use reasonable care and skill.
            </p>
            <p data-id="element-762" data-mp="2qkromnxnmupb">
              We are not responsible for loss that is not foreseeable, for money
              another member fails to pay you, or for decisions you make based
              on figures entered by members. Nothing in these terms limits our
              liability for death or personal injury caused by our negligence,
              for fraud, or for anything else that cannot be limited by law.
              Nothing in these terms affects your legal rights as a consumer.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-763" data-mp="15bzt3tvoexd6">
              15. Changes to these terms
            </h2>
            <p data-id="element-764" data-mp="vbz3jq77rl0j">
              We may update these terms as the Service develops. If a change
              materially affects you, we will give reasonable notice. Continuing
              to use KittyPot after a change means you accept the updated terms.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-765" data-mp="2uol4kg1kt1rp">
              16. Governing law
            </h2>
            <p data-id="element-766" data-mp="j0oowuzyivuy">
              These terms are governed by the law of England and Wales, and the
              courts of England and Wales have jurisdiction. If you live
              elsewhere in the UK, you may bring proceedings in your local
              courts.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-767" data-mp="o0ay8tcnzryh">
              17. Contact us
            </h2>
            <p data-id="element-768" data-mp="11qy0gvhmvzzb">
              Questions about these terms? Email{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-769" data-mp="xq4dc4c0mp7h">
                {SUPPORT_EMAIL}
              </a>{' '}
              or write to us:
            </p>
            <address className="not-italic" data-id="element-770" data-mp="3dh8o26ucj76g">
              {COMPANY.addressLines.map(line => <React.Fragment key={line} data-id="element-771" data-mp="38i5imlageyxy">
                  {line}
                  <br data-id="element-772" data-mp="38k04q2xgox3m" />
                </React.Fragment>)}
            </address>
          </div>
        </div>
      </main>
      <Footer data-id="element-773" data-mp="1he40516g3916" />
    </div>;
}